import { GA4Event, GA360Event } from '@personal-area/global/gtm';

export function isGA4Event(event: GA360Event | GA4Event): event is GA4Event {
  return event && 'context' in event && 'object' in event && 'action' in event;
}
